import React from 'react';
import classNames from 'classnames';

interface BillingPeriodToggleProps {
  period: 'month' | 'year';
  onToggle: (period: 'month' | 'year') => void;
  showSavingsBadge?: boolean;
  className?: string;
}

const BillingPeriodToggle: React.FC<BillingPeriodToggleProps> = ({
  period,
  onToggle,
  showSavingsBadge = true,
  className = '',
}) => {

  return (
    <div className={`flex items-center gap-2.5 lg:gap-3 text-[13px]/[1.2] md:text-base ${className}`}>
      <span
        className={classNames(
          "font-medium cursor-pointer transition",
          period === 'month' ? "text-brand-green" : "text-[#A5A5A5]"
        )}
        onClick={() => onToggle('month')}
      >
        <span className="hidden lg:block">Billed monthly</span>
        <span className="block lg:hidden">Monthly</span>
      </span>

      <button
        onClick={() => onToggle(period === 'month' ? 'year' : 'month')}
        className="relative bg-[#C4BCB0] w-8 md:w-10 h-5 md:h-6 rounded-full transition-colors duration-200 ease-in-out outline-0"
        role="switch"
        aria-checked={period === 'year'}
      >
        <span className={classNames(
          "absolute left-[3px] md:left-[5px] top-[3px] md:top-[5px] w-3.5 h-3.5 bg-white rounded-full transition-transform duration-200 ease-in-out",
          period === 'year' ? "translate-x-3 md:translate-x-4" : "translate-x-0"
        )} />
      </button>

      <div className="flex items-center gap-2.5">
        <span
          className={classNames(
            "font-medium cursor-pointer transition",
            period === 'year' ? "text-brand-green" : "text-[#A5A5A5]"
          )}
          onClick={() => onToggle('year')}
        >
          <span className="hidden lg:block">Billed annually</span>
          <span className="block lg:hidden">Annually</span>
        </span>
        {showSavingsBadge && (
          <span className="bg-[#D9CFFF] font-medium px-2 py-1.5 rounded-[6px] leading-none">
            Saved 20%
          </span>
        )}
      </div>
    </div>
  );
};

export default BillingPeriodToggle;
